import {
  trigger,
  style,
  animate,
  transition,
  state,
  group
} from '@angular/animations';

/**
 * This is the animation for ease-in-out
 */
export const easeInOutAnimation = trigger(
  'easeInOutAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('250ms ease-in-out', style({ opacity: '1' }))
    ]),
    transition(':leave', [
      animate('250ms ease-in-out', style({ opacity: '0' }))
    ])
  ]
);

export const easeInAnimation = trigger(
  'easeInAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('250ms ease-in-out', style({ opacity: '1' }))
    ])
  ]
);

/**
 * This is the animation for slide-in-out
 */
export const slideInOutAnimation = trigger(
  'slideInOutAnimation', [
    state('in', style({ height: '*', opacity: 0 })),
    transition(':enter', [
      style({ height: '0', opacity: 0 }),
      group([
        animate(200, style({ height: '*' })),
        animate('250ms ease-in-out', style({ opacity: '1' }))
      ])
    ]),
    transition(':leave', [
      style({ height: '*', opacity: 1 }),
      group([
        animate(200, style({ height: 0 })),
        animate('250ms ease-in-out', style({ opacity: '0' }))
      ])
    ])
  ]
);

/**
 * This is the animation for expand icon
 */
export const expandAnimation = trigger(
  'expandAnimation', [
    state('collapse', style({
      transform: 'rotate(0deg)'
    })),
    state('expand', style({
      transform: 'rotate(90deg)', transformOrigin: 'center center'
    })),
    transition('collapse => expand', [
      animate('250ms ease-in-out')
    ]),
    transition('expand => collapse', [
      animate('250ms ease-in-out')
    ])
  ]
);
